var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteadyGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#00BB98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 48C31.7956 48 32.5587 47.6839 33.1213 47.1213C33.6839 46.5587 34 45.7956 34 45C34.0098 44.9002 34.0098 44.7998 34 44.7L39.58 39.12H40.5L43.72 42.34V42.5C43.72 43.2956 44.0361 44.0587 44.5987 44.6213C45.1613 45.1839 45.9244 45.5 46.72 45.5C47.5156 45.5 48.2787 45.1839 48.8413 44.6213C49.4039 44.0587 49.72 43.2956 49.72 42.5V42.34L57 35C57.5933 35 58.1734 34.8241 58.6667 34.4944C59.1601 34.1648 59.5446 33.6962 59.7716 33.1481C59.9987 32.5999 60.0581 31.9967 59.9424 31.4147C59.8266 30.8328 59.5409 30.2982 59.1213 29.8787C58.7018 29.4591 58.1672 29.1734 57.5853 29.0576C57.0033 28.9419 56.4001 29.0013 55.852 29.2284C55.3038 29.4554 54.8352 29.8399 54.5056 30.3333C54.1759 30.8266 54 31.4067 54 32C53.9902 32.0998 53.9902 32.2002 54 32.3L46.78 39.52H46.46L43 36C43 35.2044 42.6839 34.4413 42.1213 33.8787C41.5587 33.3161 40.7956 33 40 33C39.2044 33 38.4413 33.3161 37.8787 33.8787C37.3161 34.4413 37 35.2044 37 36L31 42C30.2044 42 29.4413 42.3161 28.8787 42.8787C28.3161 43.4413 28 44.2044 28 45C28 45.7956 28.3161 46.5587 28.8787 47.1213C29.4413 47.6839 30.2044 48 31 48ZM58 56H24V22C24 21.4696 23.7893 20.9609 23.4142 20.5858C23.0391 20.2107 22.5304 20 22 20C21.4696 20 20.9609 20.2107 20.5858 20.5858C20.2107 20.9609 20 21.4696 20 22V58C20 58.5304 20.2107 59.0391 20.5858 59.4142C20.9609 59.7893 21.4696 60 22 60H58C58.5304 60 59.0391 59.7893 59.4142 59.4142C59.7893 59.0391 60 58.5304 60 58C60 57.4696 59.7893 56.9609 59.4142 56.5858C59.0391 56.2107 58.5304 56 58 56Z",
    fill: "#00BB98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteadyGrowth);
export default __webpack_public_path__ + "static/media/SteadyGrowth.5e94a276f9a1404160012871ab42d886.svg";
export { ForwardRef as ReactComponent };